import HeaderComponent from "../../components/HeaderComponent";
import SidebarComponent from "../../components/SidebarComponent";
import PaymentComponent from "./components/PaymentComponent";

function Payment() {
    return (
        <>
            <HeaderComponent/>
            <SidebarComponent activeMenu={['sidemenu-list active', 'sidemenu-list', 'sidemenu-list']}/>
            <PaymentComponent/>
        </>
    )
}

export default Payment;